'use client';

import { useEffect, useState } from 'react';

type Lang = 'en' | 'es' | 'pt' | 'de' | 'fr';

const policyTitles: Record<string, Record<Lang, string>> = {
  'Privacy Policy': {
    en: 'Privacy Policy',
    es: 'Política de Privacidad',
    pt: 'Política de Privacidade',
    de: 'Datenschutzrichtlinie',
    fr: 'Politique de confidentialité',
  },
  'Terms of Service': {
    en: 'Terms of Service',
    es: 'Términos de Servicio',
    pt: 'Termos de Serviço',
    de: 'Nutzungsbedingungen',
    fr: 'Conditions d\'utilisation',
  },
  'Cookie Policy': {
    en: 'Cookie Policy',
    es: 'Política de Cookies',
    pt: 'Política de Cookies',
    de: 'Cookie-Richtlinie',
    fr: 'Politique en matière de cookies',
  },
  'Disclaimer': {
    en: 'Disclaimer',
    es: 'Descargo de Responsabilidad',
    pt: 'Aviso Legal',
    de: 'Haftungsausschluss',
    fr: 'Avertissement',
  },
};

export function TermlyPolicy({ policyId, title }: { policyId: string; title: string }) {
  const [lang, setLang] = useState<Lang>('en');

  useEffect(() => {
    // Same cascade as the rest of the app: cookie → legacy localStorage →
    // browser preference. Ensures coming from the landing or from a direct
    // /privacy hit both show the right title.
    const cookieMatch = typeof document !== 'undefined'
      ? document.cookie.match(/ezdocu-locale=([^;]+)/)
      : null;
    const fromCookie = cookieMatch?.[1];
    if (fromCookie && ['en', 'es', 'pt', 'de', 'fr'].includes(fromCookie)) {
      setLang(fromCookie as Lang);
      return;
    }
    const saved = localStorage.getItem('lang') as Lang;
    if (saved && ['en', 'es', 'pt', 'de', 'fr'].includes(saved)) {
      setLang(saved);
      return;
    }
    const browserLang = navigator.language?.split('-')[0] || 'en';
    if (['es', 'pt', 'de', 'fr'].includes(browserLang)) {
      setLang(browserLang as Lang);
    }
  }, []);

  const translatedTitle = policyTitles[title]?.[lang] || title;

  return (
    <div className="w-full h-[calc(100vh-120px)]">
      <iframe
        src={`https://app.termly.io/policy-viewer/policy.html?policyUUID=${policyId}`}
        className="w-full h-full border-0"
        title={translatedTitle}
      />
    </div>
  );
}
